import { useEffect } from "react";
import "../styles/main.scss";

interface InstallHelpModalProps {
  isIOS: boolean;
  isAndroid: boolean;
  hasNativePrompt: boolean;
  onClose: () => void;
}

export function InstallHelpModal({ isIOS, isAndroid, hasNativePrompt, onClose }: InstallHelpModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div role="dialog" aria-modal="true" aria-label="Install instructions" onClick={onClose}
      className="install-help-modal">
      <div onClick={(e)=>e.stopPropagation()} className="install-help-modal__content">
        <div className="install-help-modal__header">
          <strong>Install BlinkBli</strong>
          <button onClick={onClose} aria-label="Close" className="install-help-modal__close-button">×</button>
        </div>
        {isIOS && (
          <ol className="install-help-modal__instructions">
            <li>Open this page in <b>Safari</b> (iOS installs only from Safari).</li>
            <li>Tap the <b>Share</b> icon (square with an up arrow).</li>
            <li>Select <b>Add to Home Screen</b>.</li>
            <li>Optionally rename, then tap <b>Add</b>.</li>
          </ol>
        )}
        {isAndroid && (
          <>
            <p className="install-help-modal__platform-title">In Chrome:</p>
            <ol className="install-help-modal__instructions">
              <li>Tap the <b>⋮</b> menu (top right).</li>
              <li>Tap <b>Install app</b> (or <b>Add to Home screen</b>).</li>
              <li>Confirm by tapping <b>Install</b>.</li>
            </ol>
            {!hasNativePrompt && (<p className="install-help-modal__fallback">Don't see the Install option? Use Chrome and open this page directly (not an in-app browser), then try again.</p>)}
          </>
        )}
        {!isIOS && !isAndroid && (<p className="install-help-modal__fallback">This device/browser may not support mobile PWA installation. Try Safari on iOS or Chrome on Android.</p>)}
        <hr className="install-help-modal__divider"/>
        <details className="install-help-modal__details">
          <summary>Why don't I see the Install button?</summary>
          <ul>
            <li>Your browser may not support the install prompt.</li>
            <li>You might be in an in-app browser (e.g., from a social app). Open in Safari/Chrome.</li>
            <li>The prompt can appear only once; reload this page to try again.</li>
          </ul>
        </details>
      </div>
    </div>
  );
}
